/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reseller_Pricing_Empty_TitleInputs */

const id_reseller_pricing_empty_title = /** @type {(inputs: Reseller_Pricing_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada TLD yang ditawarkan`)
};

const en_reseller_pricing_empty_title = /** @type {(inputs: Reseller_Pricing_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No TLD offered yet`)
};

/**
* | output |
* | --- |
* | "No TLD offered yet" |
*
* @param {Reseller_Pricing_Empty_TitleInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_empty_title = /** @type {((inputs?: Reseller_Pricing_Empty_TitleInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_Empty_TitleInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_empty_title(inputs)
	return id_reseller_pricing_empty_title(inputs)
});